<template>
  <div id="nav-menu">
    <div
      class="firm-name row-center"
      style="justify-content: flex-start; padding-left: 44rem"
    >
      <!-- <span>{{ $store.state.firm.firm.firmName }}</span> -->
      <span>{{ KJallName }}</span>
    </div>
    <el-menu router unique-opened :default-active="current" background-color="#ffffff" text-color="#333333"
        active-text-color="#0D94FF" v-if="HomeLogin == 1">
        <template v-for="(item, index) in filterMenu">
            <el-submenu v-if="item.list.length !== 0" :index="'' + index" :key="index">
                <template slot="title">
                    <i :class="item.icon" v-if="item.icon"></i>
                    <span>{{ item.title }}</span>
                </template>
                <el-menu-item-group v-if="item.list">
                  <template v-for="(sub, subIndex) in item.list" >
                      <el-menu-item @click="setNav(item.title + '/' + sub.title)" 
                          :key="subIndex" :index="sub.path" >{{ sub.title }}</el-menu-item>
                      <el-menu-item  v-if="sub.list&&sub.list.length>0"  @click="setNav(item.title + '/' + sub.title)"  v-for="(elm, elmIndex) in sub.list"
                          :key="elmIndex" :index="elm.path" class="twotitle">{{ elm.title }}</el-menu-item>
                  </template>
                  
                </el-menu-item-group>
            </el-submenu>

            <el-menu-item v-else :key="index" :index="item.path" @click="setNav(item.title)">
                <i :class="item.icon" v-if="item.icon"></i>
                <span slot="title">{{ item.title }}</span>
            </el-menu-item>
        </template>
    </el-menu>
    <el-menu
      v-else-if="HomeLogin == 2"
      router
      unique-opened
      :default-active="current"
      background-color="#ffffff"
      text-color="#333333"
      active-text-color="#0D94FF"
    >
      <template v-for="(item, index) in Homeprop">
        <el-submenu
          v-if="item.list.length !== 0"
          :index="'' + index"
          :key="index"
        >
          <template slot="title">
            <i :class="item.icon" v-if="item.icon"></i>
            <span>{{ item.title }}</span>
          </template>
          <el-menu-item-group v-if="item.list">
            <el-menu-item
              @click="setNav(item.title + '/' + sub.title)"
              v-for="(sub, subIndex) in item.list"
              :key="subIndex"
              :index="sub.path"
              >{{ sub.title }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item
          v-else
          :key="index"
          :index="item.path"
          @click="setNav(item.title)"
        >
          <i :class="item.icon" v-if="item.icon"></i>
          <span slot="title">{{ item.title }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { chainIndex } from "../../api/linkindex";
export default {
  name: "NavMenu",
  data() {
    return {
      KJallName: "",
      HomeLogin: 1,
      Homeprop: [
        {
          icon: "",
          title: "成员管理",
          path: "/admin/MemberManagement",
          list: [],
        },
        {
          icon: "",
          title: "企业信息",
          path: "/admin/EnterpriseInformation",
          list: [],
        },
      ],
      menus: [
        {
          icon: "",
          title: "首页概况",
          list: [
            {
              icon: "",
              path: "/SubstationManagement",
              title: "园区总览"
            },
            {
              icon: "",
              path: "/3D/all",
              title: "园区三维总览",
              // list:[
                // {
                //   icon: "",
                //   path: "/3D/all",
                //   title: "园区总览",
                // },
                // {
                //   icon: "",
                //   path: "/3D/site",
                //   title: "变配电概况",
                // },
                // {
                //   icon: "",
                //   path: "/3D/guang",
                //   title: "光伏概况",
                // },
                // {
                //   icon: "",
                //   path: "/3D/energy",
                //   title: "储能概况",
                // },
              // ]
            },
          ],
        },
        {
          icon: "",
          title: "一次图监控",
          path: "/diagram",
          list: [],
        },
        {
          icon: "",
          title: "变配电监测",
          list: [
            {
              icon: "",
              path: "/power-data/PowerData/none",
              title: "回路监测",
            },
            {
              icon: "",
              path: "/power-data/Transformer/none",
              title: "变压器监测",
            },
            {
                icon: "",
                path: "/power-data/Breaker/none",
                title: "断路器监测",
            },
          ],
        },
        {
          icon: "",
          title: "微电网监测",
          list: [
            {
              icon: "",
              path: "/power-data/Inverter/none",
              title: "逆变器",
            },
            {
              icon: "",
              path: "/power-data/EnergyStorage/none",
              title: "储能变流器",
            },
            {
              icon: "",
              path: "/power-data/Battery/none",
              title: "储能电池",
            },
          ],
        },
        {
          icon: "",
          title: "能效分析",
          list: [
            // {
            //     icon: "",
            //     path: "/power-data/PowerData/none",
            //     title: "回路监测",
            // },
            {
              icon: "",
              path: "/Energy/Overview/none",
              title: "用电综览",
            },
            {
              icon: "",
              path: "/Energy/Ranking/none",
              title: "用电排名",
            },
            {
              icon: "",
              path: "/Energy/Comparison/none",
              title: "用电对比",
            },
            {
              icon: "",
              path: "/Energy/Pinnacle/none",
              title: "尖峰平谷分析",
            },
            {
              icon: "",
              path: "/power-data/Transformer/two",
              title: "变压器经济运行",
            },
            {
              icon: "",
              path: "/Energy/Bill/none",
              title: "力调电费",
            },
            // {
            //     icon: "",
            //     path: "/power-data/Breaker/none",
            //     title: "断路器监测",
            // },
          ],
        },
        {
          icon: "",
          title: "电能质量",
          path: "",
          list: [
            {
              icon: "",
              title: "电容补偿",
              path: "/power-data/CapacitanceCompensation/none",
            },
          ],
        },
        
        {
          icon: "",
          title: "事件管理",
          list: [
            {
              icon: "",
              path: "/accident-analysis",
              title: "事件分析",
            },
            {
              icon: "",
              path: "/Unconfirmed-event/unconfirmed",
              title: "未确认事件",
            },
            {
              icon: "",
              path: "/Unconfirmed-event/Historical",
              title: "历史事件",
            },
            // {
            //   icon: "",
            //   path: "/accident/TELEMETRY_DISPLACEMENT",
            //   title: "跳闸报警",
            // },
            // {
            //   icon: "",
            //   path: "/accident/TELEMETRY_OVERRUN",
            //   title: "越限异常",
            // },
            // {
            //   icon: "",
            //   path: "/accident/EQUIPMENT_FAILURE",
            //   title: "网关离线",
            // },
            // {
            //     icon: "",
            //     path: "/accident/ DEVICE_FAILURE",
            //     title: "设备异常",
            // },
          ],
        },
        {
          icon: "",
          title: "报表管理",
          path: "",
          list: [
            {
              icon: "",
              title: "发电量时段报表",
              path: "/power-data/Inverter/energy",
            },
            {
              icon: "",
              title: "充放电量时段报表",
              path: "/power-data/Battery/Issue",
            },
            {
              icon: "",
              title: "用电量时段报表",
              path: "/power-data/Extremum/PowerTime",
            },
            {
              icon: "",
              title: "尖峰平谷报表",
              path: "/power-data/Extremum/Range",
            },
            {
              icon: "",
              path: "/power-data/Running/none",
              title: "电力运行报表",
            },
            {
              icon: "",
              path: "/power-data/Extremum/none",
              title: "电力极值报表",
            },
          ],
        },
        // {
        // 	icon: "",
        // 	title: "预付费",
        // 	list: [
        // 		{
        // 			icon: "",
        // 			path: "/remoteCopy",
        // 			title: "远程抄表"
        // 		},
        // 		{
        // 			icon: "",
        // 			path: "/ElectricityCharge",
        // 			title: "电费收取记录"
        // 		},
        // 		{
        // 			icon: "",
        // 			path: "/Ammeter",
        // 			title: "电表设置"
        // 		},

        // 	]
        // },
        {
          icon: "",
          title: "资产管理",
          list: [
            {
              icon: "",
              path: "/equipment-ledger",
              title: "设备台账",
            },
            {
              icon: "",
              path: "/document-management",
              title: "文档管理",
            },
          ],
        },
        // {
        //   icon: "",
        //   title: "光伏储能",
        //   list: [
        //     {
        //       icon: "",
        //       path: "/pvpower",
        //       title: "光伏发电",
        //     },
        //     {
        //       icon: "",
        //       path: "/pvmonitor",
        //       title: "储能监测",
        //     },
        //   ],
        // },
        {
          icon: "",
          title: "运行环境",
          list: [
            {
              icon: "",
              path: "/environmentalMonitoring",
              title: "环境监测",
            },
            // {
            //   icon: "",
            //   path: "/securityMonitoring",
            //   title: "安防监控",
            // },
            {
              icon: "",
              path: "",
              title: "监控视频",
            },
            {
              icon: "",
              path: "/communicationStatus",
              title: "通讯状态",
            },
          ],
        },
      ],
    };
  },
  computed: {
    projectId: function() {
      return this.$store.getters.projectId;
    },
    routePath() {
      return this.$route.path;
    },
    current() {

      return this.$route.path;
    },
    filterMenu() {
      // if (this.projectId === 3) {
      //     this.menus.filter((item) => {
      //         return item.title !== "电能质量";
      //     });
      // }
      // if (this.projectId === 4) {
      //   let first = this.menus.filter((item) => item.title !== "光伏储能");
      //   first.forEach((item, index1) => {
      //     item.list.forEach((value, index2) => {
      //       if (value.title == "文档管理") first[index1].list.splice(index2, 1);
      //     });
      //   });
      //   return first;
      // } else if (this.projectId === 3) {
      //   let first = this.menus.filter(
      //     (item) => item.title !== "光伏储能" && item.title !== "电能质量"
      //   );
      //   first.forEach((item, index1) => {
      //     item.list.forEach((value, index2) => {
      //       if (value.title == "断路器监测")
      //       // if (value.title == "设备异常" || value.title == "断路器监测")
      //         first[index1].list.splice(index2, 1);
      //     });
      //   });
      //   return first;
      // } else if (this.projectId === 1) {
      //   let first = this.menus.filter(
      //     (item) => item.title !== "光伏储能" && item.title !== "电能质量"
      //   );
      //   return first;
      // } else {
      //   let first = this.menus.filter((item) => item.title !== "光伏储能");
      //   return first;
      // }
      //  let first = this.menus.filter(
      //     (item) => item.title !== "光伏储能" && item.title !== "电能质量"
      //   );
        return this.menus;
    },
  },
  watch: {
    routePath(n) {
      this.$root.$nav.init(this.findTitle(n, this.menus));
    },
  },
  methods: {
    //电力监测
    // 湖光保护
    BarProp() {
      if (this.projectId == 4) {
        this.$set(this.menus[2].list, 3, {
          icon: "",
          path: "/power-data/protect1/none",
          title: "弧光保护",
          list: [],
        });
        this.$set(this.menus[3].list, 1, {
          icon: "",
          title: "谐波分析",
          path: "/power-data/PowerQuality/none",
          list: [],
        });
        this.$set(this.menus[5].list, 4, {
          icon: "",
          path: "/accident/DEVICE_FAILURE",
          title: "设备异常",
          list: [],
        });
      }
    },
    parkName() {
      this.id = this.$store.state.project.currentProject.projectId;
      chainIndex.getData(this.id).then((res) => {
        this.KJallName = res.data.data.project.projectName;
      });
    },
    findTitle(path, list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].path === path) {
          return list[i].title;
        }
      }

      for (let i = 0; i < list.length; i++) {
        if (list[i].list) {
          let findTitle = this.findTitle(path, list[i].list);
          if (findTitle) {
            return list[i].title + "/" + findTitle;
          }
        }
      }

      return null;
    },
    setNav(s) {
      if(s=='运行环境/监控视频'){
        let name = this.$store.state.homeitem.user.username;
        let userimg = this.$store.state.homeitem.user.img;
        window.open("http://chvideo.energydt.cn:7001/chvideo/index.html?name="+name+'&userimg='+userimg,"_blank");
      }
      //console.log(s)
    },
    //初始菜单
    getSelection() {
      // debugger
      if (sessionStorage.getItem("NavformDataIdch") == 1) {
        this.HomeLogin = sessionStorage.getItem("NavformDataIdch");
      } else if (sessionStorage.getItem("NavformDataIdch") == 2) {
        this.HomeLogin = sessionStorage.getItem("NavformDataIdch");
      } else {
        if (this.$store.state.homeitem.IformId == 2) {
          this.HomeLogin = this.$store.state.homeitem.IformId;
        } else {
          this.HomeLogin = this.$store.state.homeitem.IformId;
        }
      }
    },
  },
  created() {
    this.getSelection();
    this.parkName();
  },
  mounted() {
    // console.log(this.$store.state.homeitem.IformId)
    // this.BarProp();
    this.$root.$nav.init(this.findTitle(this.routePath, this.menus));
  },
};
</script>

<style scoped lang="less">
#nav-menu .el-menu .el-menu-item-group .el-menu-item.swei{
  color: #333333 !important;
}
#nav-menu .el-menu .el-menu-item-group .el-menu-item.twotitle {
  color: #666666 !important;
  text-indent: 35rem !important;
  .el-menu-item-group__title{
    font-size: 18rem;
    color: #333333;
    padding-left: 40rem;
  }
  .el-menu-item{
    color: #666666;
    text-indent: 35rem;
  }
}


.el-menu::-webkit-scrollbar {
  display: none !important;
}

#nav-menu {
  height: 100%;
  overflow: hidden;
  /*border-right: 0.5px solid #E5E5E5;*/
  box-shadow: 0 0 5px 1px #e5e5e5;

  * {
    border-right: none !important;
  }

  .firm-name {
    width: 100%;
    height: 11.8%;
    font-size: 18rem;
    font-weight: bold;
    color: #333333;
    border-bottom: 1px solid #e5e5e5 !important;
  }

  .el-menu {
    height: 88.2%;
    overflow: scroll;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    padding: 0;
    margin: 0;

    .el-menu-item {
      padding-left: 40rem !important;
      font-size: 18rem !important;
      color: #333333;
      font-weight: bold;
      .h(65);
      line-height: 6vh;
    }

    .el-menu-item-group {
      .el-menu-item {
        padding-left: 40rem !important;
        font-size: 18rem !important;
        color: #999999 !important;
        line-height: 6vh;
        font-weight: normal;
      }

      .is-active {
        color: #0d94ff !important;
        font-weight: bold;
      }
    }
  }
}
</style>
